import makeApiCall from "../master/axiosIndex";

const InventoryAnalyticsAPI = {
  fetchMonthOnMonthInventoryTrend: (data: any): Promise<any> => {
    const payload = { ...data };
    if (payload.siteId !== undefined && payload.siteId !== null) {
      payload.siteId = String(payload.siteId);
    }
    return makeApiCall<any>({
      url: "/inventory-dashboard/getMonthlyInventoryData",
      method: "post",
      data: payload,
    });
  },
  fetchAverageInventoryHoldingDaysByMaterial: (data: any): Promise<any> => {
    const payload = { ...data };
    if (payload.siteId !== undefined && payload.siteId !== null) {
      payload.siteId = String(payload.siteId);
    }
    return makeApiCall<any>({
      url: "/inventory-dashboard/getHoldingQuantityDetails",
      method: "post",
      data: payload,
    });
  },
  fetchMaterialWiseInventoryPurchasedvsUtilization: (data: any): Promise<any> => {
    const payload = { ...data };
    if (payload.siteId !== undefined && payload.siteId !== null) {
      payload.siteId = String(payload.siteId);
    }
    return makeApiCall<any>({
      url: "/inventory-dashboard/getMaterialHandoverDetails",
      method: "post",
      data: payload,
    });
  },
  fetchWidgetData: (data: any): Promise<any> => {
    const payload = { ...data };
    if (payload.siteId !== undefined && payload.siteId !== null) {
      payload.siteId = String(payload.siteId);
    }
    return makeApiCall<any>({
      url: "/inventory-dashboard/getInventorySummaryData",
      method: "post",
      data: payload,
    });
  },
  fetchAverageInventoryValueByMaterial: (data: any): Promise<any> => {
    const payload = { ...data };
    if (payload.siteId !== undefined && payload.siteId !== null) {
      payload.siteId = String(payload.siteId);
    }
    return makeApiCall<any>({
      url: "/inventory-dashboard/getInventoryDetails",
      method: "post",
      data: payload,
    });
  },
};

export default InventoryAnalyticsAPI;
